import { ApiBriefReport, BriefReport } from "../types";

/**
 * The one place the API response becomes what the screen, print layout and
 * PDF render. Only renames — every amount comes from the backend.
 */
export const normalizeBriefReport = (api: ApiBriefReport): BriefReport => ({
  project: api.project,
  mode: api.mode,
  label: api.label,
  sections: api.sections.map((s) => ({
    label: s.label,
    startDate: s.start_date,
    endDate: s.end_date,
    carryForward: s.summary.carry_forward,
    incomeTotal: s.summary.inflow_total,
    depositTotal: s.summary.deposit_total,
    expenseTotal: s.summary.expense_total,
    balanceOnHand: s.summary.balance_on_hand,
    incomeBreakdown: s.income_breakdown,
    depositBreakdown: s.deposit_breakdown,
    expenseBreakdown: s.expense_breakdown,
  })),
});
